import { render, staticRenderFns } from "./TextAddressInput.vue?vue&type=template&id=4cbf6596&scoped=true&"
import script from "./TextAddressInput.vue?vue&type=script&lang=ts&"
export * from "./TextAddressInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf6596",
  null
  
)

export default component.exports